import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { SearchSubmittedEvent } from '@atlassian/mpac-analytics';
import { withFeatureFlags } from '@atlassian/mpac-ui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getFilters } from "../../../../common/config/filters";
import CommonPropTypes from "../../../../common/constants/proptypes/CommonPropTypes";
import { ANALYTICS_SUBJECT_ID_STANDARD_TEXT_SEARCH, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_FILTER } from "../../../constants/analytics/events";
import { SEARCH } from "../../../constants/perspectives";
import AddonDiscoveryPropTypes from "../../../constants/proptypes/AddonDiscoveryPropTypes";

var TextSearchWrapper = /*#__PURE__*/function (_Component) {
  _inherits(TextSearchWrapper, _Component);

  var _super = _createSuper(TextSearchWrapper);

  function TextSearchWrapper() {
    var _this;

    _classCallCheck(this, TextSearchWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      query: _this.props.filters.get(getFilters({
        featureFlags: {
          enableJsdToJsm: _this.props.enableJsdToJsm,
          enableDiscoverEcosystemCloudApps: _this.props.enableDiscoverEcosystemCloudApps
        }
      }).getIn(['query', 'key'])) || ''
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeQuery", function (query) {
      _this.setState({
        query: query || ''
      });

      if (_this.props.onChange) {
        _this.props.onChange({
          query: query,
          newFilters: _this.props.filters.set(getFilters({
            featureFlags: {
              enableJsdToJsm: _this.props.enableJsdToJsm,
              enableDiscoverEcosystemCloudApps: _this.props.enableDiscoverEcosystemCloudApps
            }
          }).getIn(['query', 'key']), query)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (e) {
      e.preventDefault();

      if (!_this.props.onChange) {
        var newFilters = _this.props.filters.set(getFilters({
          featureFlags: {
            enableJsdToJsm: _this.props.enableJsdToJsm,
            enableDiscoverEcosystemCloudApps: _this.props.enableDiscoverEcosystemCloudApps
          }
        }).getIn(['query', 'key']), _this.state.query);

        _this.props.createAnalyticsEvent({
          eventType: SearchSubmittedEvent,
          actionSubjectId: ANALYTICS_SUBJECT_ID_STANDARD_TEXT_SEARCH,
          source: EVENT_SOURCE,
          objectType: OBJECT_TYPE_FILTER,
          objectId: 'query',
          attributes: {
            currentPerspective: _this.props.perspective,
            filterValue: _this.state.query
          }
        }).fire(EVENT_CHANNEL);

        _this.props.stateChangeRequested({
          filters: newFilters,
          perspective: SEARCH
        });
      }
    });

    return _this;
  }

  _createClass(TextSearchWrapper, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      var currentQuery = newProps.filters.get(getFilters({
        featureFlags: {
          enableJsdToJsm: this.props.enableJsdToJsm,
          enableDiscoverEcosystemCloudApps: this.props.enableDiscoverEcosystemCloudApps
        }
      }).getIn(['query', 'key']));
      var prevQuery = this.props.filters.get(getFilters({
        featureFlags: {
          enableJsdToJsm: this.props.enableJsdToJsm,
          enableDiscoverEcosystemCloudApps: this.props.enableDiscoverEcosystemCloudApps
        }
      }).getIn(['query', 'key']));

      if (prevQuery !== currentQuery) {
        this.setState({
          query: currentQuery || ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var SearchComponent = this.props.searchComponent;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: this.onSubmit
      }, /*#__PURE__*/React.createElement(SearchComponent, _extends({}, this.props.extraProps, {
        perspective: this.props.perspective,
        onChangeQuery: this.onChangeQuery,
        query: this.state.query
      })));
    }
  }]);

  return TextSearchWrapper;
}(Component);

_defineProperty(TextSearchWrapper, "propTypes", {
  createAnalyticsEvent: PropTypes.func.isRequired,
  extraProps: PropTypes.object,
  filters: CommonPropTypes.filters.isRequired,
  onChange: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,

  /**
   * searchComponent must contain an input or button element with type "submit"
   * so that the onSubmit of this component's form can be executed
   */
  searchComponent: PropTypes.func.isRequired,
  stateChangeRequested: PropTypes.func.isRequired,
  enableJsdToJsm: PropTypes.bool,
  enableDiscoverEcosystemCloudApps: PropTypes.bool
});

_defineProperty(TextSearchWrapper, "defaultProps", {
  extraProps: {}
});

export default withAnalyticsEvents()(withFeatureFlags(TextSearchWrapper));